import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import format from "date-fns/format";
import classNames from "classnames";
import { /* Typography, */ Card, Box, withStyles, Grid } from "@material-ui/core";
import styled from 'styled-components'

const styles = theme => ({
  img: {
    width: 200,
    height: 158,
    objectFit: 'cover',
    [theme.breakpoints.down("xs")]: {
      width: '100%',
      height: 100,
    },
  },
  card: {
    boxShadow: theme.shadows[2],
    background: 'transparent',
    marginBottom: 42,
    minWidth: 360
  },
  noDecoration: {
    textDecoration: "none !important"
  },
  title: {
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.complex,
      easing: theme.transitions.easing.easeInOut
    }),
    cursor: "pointer",
    color: theme.palette.secondary.main,
    "&:hover": {
      color: theme.palette.secondary.dark
    },
    "&:active": {
      color: theme.palette.primary.dark
    }
  },
  link: {
    transition: theme.transitions.create(["background-color"], {
      duration: theme.transitions.duration.complex,
      easing: theme.transitions.easing.easeInOut
    }),
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.dark
    }
  },
  showFocus: {
    "&:focus span": {
      color: theme.palette.secondary.dark
    }
  }
});

const PostDate = styled.p`
  height: 15px;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: left;
  color: #b6b8bc;
  margin: 0;
  padding-top: 4px;
`;

const PostDescription = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  margin-top: 14px;
  width: 165px;

  /* multiple line text supported ellipsis */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;


function BlogCardHorizontal(props) {
  const { classes, url, src, date, title } = props;

  return (
    <Card className={classes.card}>
      <Grid
        container
        direction="row"
        justify="center"
      >
        {src && (
          <Grid item sm={6} xs={4}>
            <Link to={url} tabIndex={-1}>
              <img src={src} className={classes.img} alt="" />
            </Link>
          </Grid>
        )}
        <Grid item sm={6} xs={8}>
          <Box pl={1}>
            <PostDate>
              {format(new Date(date), "PPP", { awareOfUnicodeTokens: true })}
            </PostDate>
            <Link
              to={url}
              className={classNames(classes.noDecoration, classes.showFocus)}
            >
              <PostDescription>
                {title}
              </PostDescription>
            </Link>
            {/* <Typography variant="body1" color="textSecondary">
              {snippet}
              <Link to={url} className={classes.noDecoration} tabIndex={-1}>
                <span className={classes.link}> read more...</span>
              </Link>
            </Typography> */}
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}

BlogCardHorizontal.propTypes = {
  classes: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.number.isRequired,
  snippet: PropTypes.string.isRequired,
  src: PropTypes.string
};

export default withStyles(styles, { withTheme: true })(BlogCardHorizontal);
